module.exports = __webpack_public_path__ + "media/images/sales/set/eyecatch-set-01-41b4f0c7e0f9d1518543a53689d645d9.svg";